import { FromJSONable } from "./FromJSONable";

export class DateDisabledDatePicker implements FromJSONable{
    public constructor(){

    }
   
    parseJSONObject(object:Object){
        if(!object){return;}
        Object.assign(this,object);
        this.DateDisabledByStationArray = []; var x:Object[] = object["dateDisabledList"];
        if(x){
            for(var i=0;i<x.length;i++){
                let y:DateDisabledByStation = new DateDisabledByStation();y.parseJSONObject(x[i]);
                this.DateDisabledByStationArray.push(y);
            }
        }
    }
    public dateMax:string;
    public DateDisabledByStationArray:DateDisabledByStation[];
}

export class DateDisabledByStation implements FromJSONable{
    public constructor(){}
 
    parseJSONObject(object:Object){
        if(!object){return;}
        Object.assign(this,object);
    }
    public DateDisabled:string;
    public StationId:number;

}
